import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl font-bold">{t("notFound.title")}</h1>
      <p className="text-lg text-gray-600">{t("notFound.description")}</p>
      <Link to="/" className="mt-4 text-blue-500 hover:underline">
        {t("notFound.backToHome")}
      </Link>
    </div>
  );
}
